import script from "./PreviewPdf.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewPdf.vue?vue&type=script&setup=true&lang=js"

import "./PreviewPdf.vue?vue&type=style&index=0&id=72ec0d2d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ec0d2d"]])

export default __exports__